import React, { useMemo, useState } from "react";
import { Checkbox, Dropdown } from "semantic-ui-react";

export type MultiSelectOption = {
  key: string | number;
  value: string | number;
  text: string;
};

type Props = {
  name?: string;
  options: MultiSelectOption[];
  value?: Array<string | number>;

  onChange?: (
    event: React.SyntheticEvent<HTMLElement>,
    data: {
      name?: string;
      value: Array<string | number>;
    },
  ) => void;

  placeholder?: string;
  disabled?: boolean;
  search?: boolean;
};

const MultiSelectCheckboxDropdown = ({
  name,
  options,
  value = [],
  onChange,
  placeholder = "กรุณาเลือก",
  disabled = false,
  search = true,
}: Props) => {
  const [open, setOpen] = useState(false);

  const selectedValues = Array.isArray(value) ? value : [];

  const handleSelect = (event: React.MouseEvent, option: MultiSelectOption) => {
    event.stopPropagation();

    const exists = selectedValues.includes(option.value);

    const newValue = exists
      ? selectedValues.filter((x) => x !== option.value)
      : [...selectedValues, option.value];

    onChange?.(event, {
      name,
      value: newValue,
    });
  };

  const dropdownOptions = useMemo(() => {
    return options.map((option) => ({
      key: option.key,
      value: option.value,

      // ไม่ใช้ text ตรง ๆ เป็นตัวแสดง
      text: option.text,

      content: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            width: "100%",
          }}
          onClick={(e) => handleSelect(e, option)}
        >
          <Checkbox
            checked={selectedValues.includes(option.value)}
            style={{
              pointerEvents: "none",
            }}
          />

          <span>{option.text}</span>
        </div>
      ),
    }));
  }, [options, selectedValues]);

  return (
    <Dropdown
      selection
      fluid
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disabled={disabled}
      search={search}
      placeholder={placeholder}
      options={dropdownOptions}
      text={
        selectedValues?.length === options?.length || selectedValues?.length === 0
          ? "ทั้งหมด"
          : selectedValues.length > 0
            ? `เลือกแล้ว ${selectedValues.length} รายการ`
            : placeholder
      }
      onChange={() => {}}
    />
  );
};

export default MultiSelectCheckboxDropdown;
